import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";
import { MeAviseTipo } from '@app/models/me-avise-tipo.model';
import { MeAviseTipoService } from '@app/services/me-avise-tipo.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-me-avise-tipo-lista',
  templateUrl: './me-avise-tipo-lista.component.html'
})
export class MeAviseTipoListaComponent implements OnInit {

  lstMeAviseTipo: MeAviseTipo[];
  paginacao: Paginacao;
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private meAviseTipoService: MeAviseTipoService,
    private modalService: BsModalService
  ) {
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.meAviseTipoService.obterTodosPesquisa(descricao, pagina)
      .subscribe(data => {
        this.lstMeAviseTipo = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(meAviseTipo: MeAviseTipo) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = " Deseja realmente excluir o tipo:  " + meAviseTipo.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.meAviseTipoService.deletar(meAviseTipo.Id).subscribe(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
